import Wave from "react-wavify";
import React from "react";

export function SingleBanner({ title, titleorange, path }) {
  return (
    <>
      <div className="banner-wave">
        <div className="single_banner">
          <div className="container_app">
            <h3>
              {title}
              <span>{titleorange}</span>
            </h3>
          </div>
        </div>
        <Wave
          className="wave_banner"
          fill="#35126c"
          paused={false}
          options={{
            height: 40,
            amplitude: 40,
            speed: 0.21,
            points: 4,
          }}
        />
      </div>
    </>
  );
}
